import React, { useState } from 'react';
import { authService } from "../../auth";
import { Link, NavLink } from "react-router-dom";

// Third Party imports
import OwlCarousel from 'react-owl-carousel';
import AuthModalComponent from "../../LoginExtra/AuthModalComponent";
import CommonHashTagsOthers from './Common/CommonHashTagsOther';

function HashTagsOthers(props) {

    const [userData, setUserData] = useState(authService.getUserDetailsFromLocalStorage())
    const [loginSuccess] = useState(authService.isAuthenticated());
    const [loginRequired, setLoginRequired] = useState(false);

    const loginRequiredFunc = () => {
        setLoginRequired(true);
        window.$("#loginModal").modal("show");
    }

    const handleLoginClose = () => {
        setLoginRequired(false);
        window.$("#loginModal").modal("hide");
    }

    return (
        <div id="hashTagOthers" className="expHashSection expHashBlogs">
            <h2 className="edtrdsk">Others</h2>

            <div className="explLatarticle">
                {/* <OwlCarousel
                    id={"projSummaryCarousel"}
                    className={"projSummaryCarousel"}
                    autoWidth={true}
                    nav={false}
                    dots={false}
                    margin={12}
                    items={3}
                    loop={false}
                    rewind={true}>
                    {props.othersListData && props.othersListData.slice(0, 3).map((item, index) => {
                        return <div className="item">
                            <CommonHashTagsOthers item={item} key={item.id} />
                        </div>
                    })
                    }
                </OwlCarousel> */}
                <div className='projSummaryCarousel row' id={"projSummaryCarousel"}>
                    {props.othersListData && props.othersListData.slice(0, 3).map((item, index) => {
                        return <div className="col-md-4">
                            <CommonHashTagsOthers item={item} key={item.id} />
                        </div>
                    })}
                </div>

                {props.othersListData && props.othersListData.length > 3 &&
                    <div className="btnblock text-center">
                        {loginSuccess === true ? (props.hashTagType === 'global' ? 
                        (<Link className="btn morebtnsm" to={"/explore-hashtag/others/" + props.tagName}>View All</Link>) : 
                        props?.hashTagType === "COMMUNITY" ? 
                            (<Link className="btn morebtnsm" to={"/community/hashtag/others/" + props.tagName + "/" + props.userName}>View All</Link>) :
                            (<Link className="btn morebtnsm" to={"/profile-hashtag/others/" + props.tagName + "/" + props.userName}>View All</Link>)

                        ) : (<a href="javascript:void(0)" onClick={loginRequiredFunc.bind(this)} className="btn morebtnsm">View All</a>
                            )}
                    </div>
                }
                {loginRequired === true ? (
                    <AuthModalComponent handleLoginClose={handleLoginClose} pathname={"/explore-hashtag/others/" + props.tagName} />
                ) : null}
            </div>
        </div>
    )
}

export default HashTagsOthers;